import httpClient from './httpClient';

const serviceService = {
    getMaintainService() {
        return httpClient.get('/api/site/service/maintenance/1');
    },
}

export default serviceService;